import { multiSelectFilterCell } from '../FilterCell'

export const WalletType = [
  { text: 'FX/CFD', value: 1 },
  { text: 'ETD', value: 2 },
  { text: 'IB FX/CFD', value: 10 },
  { text: 'Payment Agent', value: 100 },
]

export const WalletTypeFilterCell = multiSelectFilterCell({
  items: WalletType.map((x) => ({ id: x.value, value: x.value, label: x.text })),
  options: {
    operator: '==',
  },
})
